import script from "./InterviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InterviewCard.vue?vue&type=script&setup=true&lang=js"

import "./InterviewCard.vue?vue&type=style&index=0&id=23f301b2&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f301b2"]])

export default __exports__